"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const complexData_1 = __importDefault(require("@powerednow/complexData/complexData"));
const subscription_1 = require("@powerednow/shared/constants/subscription");
const entity_1 = __importDefault(require("./entity"));
const modelProperties_1 = __importDefault(require("./modelProperties"));
const modelLookup_1 = require("../modelLookup");
// eslint-disable-next-line no-redeclare
class WhiteLabel extends complexData_1.default {
    static get allowedAssociations() {
        return {
            whiteLabelToCustomer: {
                key: 'whiteLabelToCustomer',
                instance: (0, modelLookup_1.complexFindModel)('WhiteLabelToCustomer'),
                cascadeDelete: true,
                condition: {
                    whitelabel_id: this.Entity.getFieldSymbols().id,
                },
            },
        };
    }
    requiresAccountValidation() {
        return this.data.account_number_validation_rule !== '';
    }
    static isValidWhiteLabelId(whiteLabelId) {
        return Object.values(subscription_1.WHITE_LABEL_IDS).includes(whiteLabelId);
    }
    static validateWhiteLabelId(whitelabelId) {
        if (!this.isValidWhiteLabelId(whitelabelId)) {
            return subscription_1.WHITE_LABEL_IDS.POWEREDNOW;
        }
        return whitelabelId;
    }
}
WhiteLabel.Entity = entity_1.default;
WhiteLabel.modelProperties = modelProperties_1.default;
exports.default = WhiteLabel;
//# sourceMappingURL=../../../../src/models/whiteLabel/index.js.map